import { useState, useCallback, useEffect, useRef } from "react";
import * as serviceWorkerRegistration from "./serviceWorker";
export var useServiceWorker = function () {
    var _a = useState(null), waitingWorker = _a[0], setWaitingWorker = _a[1];
    var _b = useState(false), showReload = _b[0], setShowReload = _b[1];
    // Guards the controllerchange reload below against firing twice.
    var reloadingRef = useRef(false);
    // called when a service worker
    // updates. this function is a callback
    // to the actual service worker
    // registration onUpdate.
    var onSWUpdate = useCallback(function (registration) {
        setShowReload(true);
        setWaitingWorker(registration.waiting);
    }, []);
    // simply put, this tells the service
    // worker to skip the waiting phase and then reloads the page
    var reloadPage = useCallback(function () {
        reloadingRef.current = true;
        waitingWorker === null || waitingWorker === void 0 ? void 0 : waitingWorker.postMessage({ type: "SKIP_WAITING" });
        setShowReload(false);
        window.location.reload();
    }, [waitingWorker]);
    // Clicking "Refresh Now" in one tab activates the new worker for EVERY tab,
    // because service workers are shared per origin. The other tabs keep running the
    // previous bundle while now being controlled by the new worker, and die on the
    // next lazy chunk request. Reload them too.
    //
    // Only when a controller already existed: on a first-ever install the controller
    // goes from null to ours, and reloading there would be a pointless refresh on
    // someone's first visit.
    useEffect(function () {
        if (!('serviceWorker' in navigator) || !navigator.serviceWorker.controller) {
            return;
        }
        var onControllerChange = function () {
            if (reloadingRef.current) {
                return;
            }
            reloadingRef.current = true;
            window.location.reload();
        };
        navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);
        return function () { return navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange); };
    }, []);
    // Register the service worker. This is the app's only call to register() —
    // src/index.tsx deliberately does not, so that the registration and the update
    // toast share one registration object.
    useEffect(function () {
        serviceWorkerRegistration.register({
            onUpdate: onSWUpdate,
        });
    }, [onSWUpdate]);
    return { showReload: showReload, waitingWorker: waitingWorker, reloadPage: reloadPage };
};
